var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBank(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14372:56519)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.12183 13.687V25.3234",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.3596 13.687V25.3234",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.7407 13.687V25.3234",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7407 13.687V25.3234",
    stroke: "#0056CD",
    strokeWidth: 1.8,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.24718 8.31467L15.9319 1.02175C16.248 0.83998 16.6381 0.844728 16.9497 1.03414L28.9487 8.32705C29.8129 8.85227 29.4406 10.1816 28.4293 10.1816H3.74561C2.72155 10.1816 2.35939 8.82509 3.24718 8.31467Z",
    stroke: "#0056CD",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("rect", {
    x: 1.97373,
    y: 28.4049,
    width: 27.9143,
    height: 2.56364,
    rx: 1.28182,
    stroke: "#0056CD",
    strokeWidth: 1.8
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.2668 6.07262C18.2668 6.97384 17.489 7.77503 16.4404 7.77503C15.3919 7.77503 14.6141 6.97384 14.6141 6.07262C14.6141 5.17141 15.3919 4.37021 16.4404 4.37021C17.489 4.37021 18.2668 5.17141 18.2668 6.07262Z",
    stroke: "#0056CD",
    strokeWidth: 1.8
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14372:56519"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBank);
export default __webpack_public_path__ + "static/media/bank.47808dd9.svg";
export { ForwardRef as ReactComponent };